import { TFunction } from 'react-i18next';
import { AjvError } from '@rjsf/core';

/**
 * Transforms errors into i18n defined strings, based on:
 * https://react-jsonschema-form.readthedocs.io/en/latest/usage/validation/#custom-error-messages
 * @param t - translation function
 * @param errors - array of ajv errors
 * @returns
 */
export const transformErrors = (t: TFunction<'translation'>, errors: AjvError[]): AjvError[] => {
  return errors.map((error) => {
    if (error.name === 'minLength') {
      error.message = t(`ns.rjsf:error:${error.name.toLowerCase()}`, { count: error.params.limit });
    }
    if (error.name === 'required') {
      error.message = t(`ns.rjsf:error:${error.name.toLowerCase()}`);
    }
    return error;
  });
};
